import './RangeLegend.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var legendContainer = _7a468({defaultClassName:'_lvrd9i0-3-15-1',variantClassNames:{isVertical:{true:'_lvrd9i1-3-15-1',false:'_lvrd9i2-3-15-1'}},defaultVariants:{},compoundVariants:[]});